/**
* Created by bieao on 2020/4/2.
*/
<template>
    <div class="item-position statistics-today">
      <div class="title-item">
        <div class="first"></div>
        <div class="two">04</div>
        <div class="title">
          <div>Risk Statistics Today</div>
          <div>今日风险统计</div>
        </div>
      </div>
      <div class="content m-b-8">
        <div class="item">
          <div class="num">{{data.behaviorRiskTotal}}</div>
          <div class="title">
            <img src="/static/img/behavior-risk.png" alt=""/>
            <div>行为风险</div>
          </div>
        </div>
        <div class="item">
          <div class="num">{{data.bodyRiskTotal}}</div>
          <div class="title">
            <img src="/static/img/body-risk.png" alt=""/>
            <div>机体风险</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'StatisticsToday',
  props: {
    data: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
  .statistics-today{
    z-index: 2;
    left: 1490px;
    top: 30px;
    .content {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      width: 363px;
      .item{
        width:173px;
        background-size: 100% 100%;
        background: linear-gradient(90deg, rgba(11, 39, 60, 0.5) 0%, rgba(7, 25, 42, 0.5) 100%);
        padding:12px 21px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #FFFFFF;
        .num {
          font-weight: 700;
          font-size: 24px;
          margin-bottom: 8px;
        }
        .title {
          display: flex;
          align-items: center;
          img {
            width: 30px;
            margin-right: 4px;
          }
          .name {
            font-size: 16px;
          }
        }
      }
    }
    .m-b-8 {
      margin-bottom: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StatisticsToday.vue